export const extractHeadingTag = htmlString => {
  const match = htmlString.match(/^<(h[1-6])/i);
  return match ? match[1].toLowerCase() : '';
};
export const getHeadingStructure = headings => {
  return headings.map(heading => extractHeadingTag(heading.htmlString));
};
export const areStructuresEqual = (structure1, structure2) => {
  if (structure1.length !== structure2.length) {
    return false;
  }
  return structure1.every((tag, index) => tag === structure2[index]);
};
//# sourceMappingURL=heading-helpers.js.map